
    
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitCcpaRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ccpaRequestInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CcpaRequestInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitCcpaRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ccpaRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ccpaRequestInput"}}}],"directives":[]}]}}]};
  

    var useUnique = require('@graphql-tools/webpack-loader-runtime').useUnique;
    var unique = useUnique();
  

    module.exports = doc
  
